import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';

import Marketolog1 from '../../../images/pages/cases/emp-field/marketolog-1.png';
import Marketolog2 from '../../../images/pages/cases/emp-field/marketolog-2.png';
import Doctors1 from '../../../images/pages/cases/emp-field/doctors-1.png';
import Doctors2 from '../../../images/pages/cases/emp-field/doctors-2.png';
import Like from '../../../images/pages/cases/emp-field/like.png';
import Star from '../../../images/pages/cases/emp-field/star.png';
import Lovehand from '../../../images/pages/cases/emp-field/lovehand.png';
import LineIn from '../../../images/pages/cases/emp-field/line-in.png';
import LineOut from '../../../images/pages/cases/emp-field/line-out.png';

const EmpoweringField = () => {
    const Marketolog1Ref = useRef(null);
    const Marketolog2Ref = useRef(null);
    const Doctors1Ref = useRef(null);
    const Doctors2Ref = useRef(null);
    const LineInRef = useRef(null);
    const LineOutRef = useRef(null);
    const LikeRef = useRef(null);
    const Like2Ref = useRef(null);
    const StarRef = useRef(null);
    const Star2Ref = useRef(null);
    const Star3Ref = useRef(null);
    const LovehandRef = useRef(null);
    const Lovehand2Ref = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline();

        gsap.set([Marketolog1Ref.current, Doctors1Ref.current], { opacity: 1, scale: 1 });
        gsap.set([Marketolog2Ref.current, Doctors2Ref.current], { opacity: 0, scale: 1 });
        gsap.set([LineInRef.current], { opacity: 0, scale: 1 });
        gsap.set([LineOutRef.current], { opacity: 0, scale: 1 });
        gsap.set([LikeRef.current], { opacity: 0, scale: 0 });
        gsap.set([Like2Ref.current], { opacity: 0, scale: 0 });
        gsap.set([StarRef.current], { opacity: 0, scale: 0 });
        gsap.set([Star2Ref.current], { opacity: 0, scale: 0 });
        gsap.set([Star3Ref.current], { opacity: 0, scale: 0 });
        gsap.set([LovehandRef.current], { opacity: 0, scale: 0 });
        gsap.set([Lovehand2Ref.current], { opacity: 0, scale: 0 });

        tl.to(Marketolog1Ref.current, { opacity: 0, scale: 1, duration: 1, delay: 1 })
            .to(Marketolog2Ref.current, { opacity: 1, duration: 1 }, '<')
            .to(LineInRef.current, { opacity: 1, scale: 1, duration: 0.5 }, '<')
            .to(LineOutRef.current, { opacity: 1, scale: 1, duration: 0.5 })

            .to(Doctors1Ref.current, { opacity: 0, scale: 1, duration: 1 })
            .to(Doctors2Ref.current, { opacity: 1, scale: 1.7, duration: 1 }, '<')

            .to(Marketolog2Ref.current, { opacity: 1, scale: 0.65, duration: 1 }, '<')

            .to(Like2Ref.current, {
                opacity: 1,
                x: -48,
                y: -217,
                scale: 1.5,
                duration: 1,
                ease: 'power2.out',
            }, '-=0.5')

            .to(LovehandRef.current, {
                opacity: 1,
                x: 0,
                y: -150,
                scale: 1.7,
                duration: 0.8,
                ease: 'power2.out',
            }, '-=0.5')

            .to(StarRef.current, {
                opacity: 1,
                x: 0,
                y: -80,
                scale: 2,
                duration: 0.7,
                ease: 'power2.out',
            }, '-=0.5')

            .to(Star2Ref.current, {
                opacity: 1,
                x: -29,
                y: -57,
                scale: 1.6,
                duration: 0.7,
                ease: 'power2.out',
            }, '-=0.5')

            .to(LikeRef.current, {
                opacity: 1,
                x: 0,
                y: -22,
                scale: 1.5,
                duration: 1,
                ease: 'power2.out',
            }, '-=0.5')

            .to(Star3Ref.current, {
                opacity: 1,
                rotate: -29,
                x: 0,
                y: -80,
                scale: 2,
                duration: 0.7,
                ease: 'power2.out',
            }, '-=0.5')

            .to(Lovehand2Ref.current, {
                opacity: 1,
                rotate: -29,
                x: 0,
                y: -150,
                scale: 1.7,
                duration: 0.8,
                ease: 'power2.out',
            }, '-=0.5')

            .to([Like2Ref.current, LovehandRef.current, Star3Ref.current, LikeRef.current, StarRef.current, Star2Ref.current, Lovehand2Ref.current], {
                keyframes: [
                    {
                        scale: 1.8,
                        duration: 0.3,
                        ease: "power2.out"
                    },
                    {
                        scale: 1.5,
                        duration: 0.3,
                        ease: "power2.in"
                    }
                ],
                repeat: 2,
                yoyo: true
            })
            .to([Like2Ref.current, LovehandRef.current, Star3Ref.current, LikeRef.current, StarRef.current, Star2Ref.current, Lovehand2Ref.current], {
                opacity: 0,
                scale: 0.8,
                duration: 0.5,
                ease: "power2.in"
            }, '+=0.2');
    }, []);

    return (
        <div className="emp-field">
            <img src={Marketolog1} className={'emp-field__img emp-field__img--1'} alt="Case image" ref={Marketolog1Ref} />
            <img src={Marketolog2} className={'emp-field__img emp-field__img--2'} alt="Case image" ref={Marketolog2Ref} />
            <img src={Doctors1} className="emp-field__img emp-field__img--3" alt="Case image" ref={Doctors1Ref} />
            <img src={Doctors2} className="emp-field__img emp-field__img--4" alt="Case image" ref={Doctors2Ref} />
            <img src={LineIn} className="emp-field__img emp-field__img--5" alt="Case image" ref={LineInRef} />
            <img src={LineOut} className="emp-field__img emp-field__img--6" alt="Case image" ref={LineOutRef} />
            <img src={Like} className="emp-field__img emp-field__img--7" alt="Case image" ref={LikeRef} />
            <img src={Star} className="emp-field__img emp-field__img--8" alt="Case image" ref={StarRef} />
            <img src={Lovehand} className="emp-field__img emp-field__img--9" alt="Case image" ref={LovehandRef} />
            <img src={Star} className="emp-field__img emp-field__img--10" alt="Case image" ref={Star2Ref} />
            <img src={Like} className="emp-field__img emp-field__img--11" alt="Case image" ref={Like2Ref} />
            <img src={Star} className="emp-field__img emp-field__img--12" alt="Case image" ref={Star3Ref} />
            <img src={Lovehand} className="emp-field__img emp-field__img--13" alt="Case image" ref={Lovehand2Ref} />
        </div>
    );
};

export default EmpoweringField;
